"use strict";
exports.__esModule = true;
exports.PAYMENT_DETAILS = void 0;
exports.PAYMENT_DETAILS = {
    SECTION_TITLE: 'Payment details',
    PAYMENT_DATE_SECTION_TITLE: 'Payment date',
    FEE_DETAIL: 'Bill payment fee ({{processingFee}}% of rent)',
    FEE_DETAIL_CREDIT: 'Bill payment + card processing fee ({{processingFee}}% of rent)',
    FEE_DETAIL_MONTHLY_RATE: '{{processingFee}}% monthly rate',
    FEE_DETAIL_INTEREST: 'Interest ({{processingFee}}%)',
    ESTIMATED: '*Estimated',
    MAKE_PAYMENT: 'Make payment',
    TOTAL_LABEL: 'Total',
    REMAINING_BALANCE_LABEL: 'Remaining balance',
    BILL_PAYMENT_TOTAL: 'Total paid',
    ADDITIONAL_DEPOSIT: 'The rent payment you made was higher than expected. Please make your additional payment by 5pm ET on {{date}} so we can process your rent.',
    MAKE_PAYMENT_CTA: 'Make Payment',
    FUND_EARLY_CTA: 'Fund Early',
    RESCHEDULE_CTA: 'Reschedule'
};
